import { useAPIExplorer } from "../APIExplorerContext"
import {
  RequestFiltersFieldset,
  RequestFormMultiInput,
  RequestLangFieldset,
  RequestOrderingsFieldset,
  RequestRefFieldset,
  RequestTypeFieldset,
} from "./components"
import { createRequest } from "./createRequest"
import { MissingParameterError } from "./MissingParameterError"

export const GetAllByUIDsRequest = createRequest({
  type: "getAllByUIDs",
  Fieldset() {
    const { request } = useAPIExplorer()

    function setUIDs(uids: string[]) {
      request.setRequestOptions("getAllByUIDs", {
        ...request.options.getAllByUIDs,
        uids,
      })
    }

    return (
      <>
        <RequestTypeFieldset />
        <RequestFormMultiInput
          value={request.options.getAllByUIDs?.["uids"] ?? []}
          onValueChange={setUIDs}
          label="UIDs *"
          placeholder="features, pricing"
          error={
            !request.options.getAllByUIDs?.["uids"] ||
            request.options.getAllByUIDs?.["uids"].length === 0
          }
        />
        <RequestLangFieldset />
        <RequestRefFieldset />
        <RequestFiltersFieldset />
        <RequestOrderingsFieldset />
      </>
    )
  },
  getSnippetArgs(options) {
    return [
      options.type || Symbol("type"),
      options.uids?.length ? options.uids : Symbol("uids"),
      {
        lang: options.lang,
        ref: options.ref,
        filters: options.filters,
        orderings: options.orderings,
      },
    ]
  },
  run(client, options) {
    const { type, uids, ...params } = options

    if (!type || !uids?.length) {
      throw new MissingParameterError(["Type", "UIDs"])
    }

    return client.getAllByUIDs(type, uids, params)
  },
})
